import { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import ServiceCard from './ServiceCard';
import BookingModal from './BookingModal';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaArrowLeft } from 'react-icons/fa';

const BQ_BASE_URL = process.env.REACT_APP_BQ_BASE_URL;

const OrderRoomServices = () => {
  const [services, setServices] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [formData, setFormData] = useState({
    room_number: '',
    serviceid: '',
    itemid: '',
    urgencylevel: 'Normal',
    quantity: 1,
    scheduledtime: '',
    specialinstructions: '',
  });

  // Fetch room services from API
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await fetch(`${BQ_BASE_URL}/bq/api/room-service-categories/`, {
          headers: { Accept: 'application/json' },
        });
        const data = await response.json();
        setServices(data);
      } catch (error) {
        console.error('Error fetching room services:', error);
      }
    };

    fetchServices();
  }, []);

  // Handle successful booking
  const handleBookingSuccess = (bookingData) => {
    console.log('Booking successful:', bookingData);
    // You can navigate to payment page or handle payment flow here
    // For now, just show success message and close modal
    setIsModalOpen(false);
  };

  const handleBookClick = (service) => {
    setSelectedService({
      ...service,
      category_name: service.name,
    });
    setFormData({
      ...formData,
      room_number: '',
      serviceid: '',
      itemid: '',
      quantity: 1,
    });
    setIsModalOpen(true);
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
      <NavLink
        to="/dashboard/core-modules/property-management-system/front-desk-roomservices"
        className="flex items-center text-gray-400 hover:text-black mb-4"
      >
        <FaArrowLeft className="mr-3 text-md" />
        <span className="text-lg">Back to Room Services</span>
      </NavLink>

      <div className="px-10 mt-2 mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Room Services</h1>
          <h2 className="text-md font-semibold text-center mb-1 text-black">
            Enhance your stay with our premium in-room offerings designed for comfort, convenience,
            and celebration.
          </h2>
          <hr className="border border-gray-300 w-1/4 mx-auto mb-4" />
        </div>

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((service) => (
            <ServiceCard key={service.id} service={service} onBookClick={handleBookClick} />
          ))}
        </div>
      </div>

      {isModalOpen && (
        <BookingModal
          formData={formData}
          setFormData={setFormData}
          selectedService={selectedService}
          onClose={() => setIsModalOpen(false)}
          onBookingSuccess={handleBookingSuccess}
        />
      )}

      <ToastContainer />
    </div>
  );
};

export default OrderRoomServices;

// import { useState, useEffect } from 'react';
// import { NavLink } from 'react-router-dom';
// import ServiceCard from './ServiceCard';
// import BookingModal from './BookingModal';
// import { toast, ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { FaArrowLeft } from 'react-icons/fa';
// const BQ_BASE_URL = process.env.REACT_APP_BQ_BASE_URL;
// const REACT_APP_RAZORPAY_KEY = process.env.REACT_APP_RAZORPAY_KEY;

// const OrderRoomServices = () => {
//   const [services, setServices] = useState([]);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [selectedService, setSelectedService] = useState(null);
//   const [formData, setFormData] = useState({
//     serviceName: '',
//     itemName: '',
//     urgencyLevel: 'Normal',
//     quantity: '',
//     scheduleTime: '',
//     requestedTime: new Date().toISOString().slice(0, 16),
//     specialInstruction: '',
//   });

//   const [showPaymentModal, setShowPaymentModal] = useState(false);
//   const [razorpayLoaded, setRazorpayLoaded] = useState(false);

//   const bookingDetails = JSON.parse(sessionStorage.getItem('bookingDetails')) || {};

//   // Fetch room services from API
//   useEffect(() => {
//     const fetchServices = async () => {
//       try {
//         const response = await fetch(`${BQ_BASE_URL}/bq/api/room-service-categories/`, {
//           headers: { Accept: 'application/json' },
//         });
//         const data = await response.json();
//         setServices(data); // ✅ Store all services, no filtering!
//       } catch (error) {
//         console.error('Error fetching room services:', error);
//       }
//     };

//     fetchServices();
//   }, []);

//   const confirmServiceBooking = async () => {
//     try {
//       // Add category_name to the query parameters
//       const url = new URL(`${BQ_BASE_URL}/bq/api/create_room_service_billing`);
//       url.searchParams.append('bookingid', bookingDetails.bookingid);
//       url.searchParams.append('category_name', selectedService.category_name); // Make sure selectedService has this property

//       const response = await fetch(url.toString(), {
//         method: 'POST',
//         headers: {
//           Accept: 'application/json',
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify([selectedService.roomservice_name]),
//       });

//       if (response.ok) {
//         const data = await response.json();
//         sessionStorage.setItem('billingDetails', JSON.stringify(data));
//         sessionStorage.setItem('selectedService', JSON.stringify(selectedService));
//         toast.success('Service confirmed successfully');
//         closeConfirmationModal();
//         setShowPaymentModal(true);
//       } else {
//         const errorData = await response.json();
//         toast.error(errorData.detail?.[0]?.msg || 'Failed to confirm service.');
//       }
//     } catch (error) {
//       toast.error('An error occurred while confirming the service.');
//     }
//   };

//   const closeConfirmationModal = () => {
//     setSelectedService(null);
//   };

//   useEffect(() => {
//     const loadRazorpayScript = () => {
//       const script = document.createElement('script');
//       script.src = 'https://checkout.razorpay.com/v1/checkout.js';
//       script.async = true;
//       script.onload = () => setRazorpayLoaded(true);
//       script.onerror = () => {
//         toast.error('Error loading Razorpay script. Please try again.');
//       };
//       document.body.appendChild(script);
//     };

//     loadRazorpayScript();
//   }, []);

//   const handlePaymentOption = async (paymentMethod) => {
//     if (!razorpayLoaded) {
//       toast.error('Razorpay script is not loaded yet.');
//       return;
//     }

//     if (paymentMethod === 'payNow') {
//       try {
//         // Retrieve selected service from localStorage
//         const selectedService = JSON.parse(sessionStorage.getItem('selectedService'));
//         if (!selectedService) {
//           toast.error('No service selected for payment.');
//           return;
//         }

//         // Retrieve billing details from localStorage
//         const billingDetails = JSON.parse(sessionStorage.getItem('billingDetails'));
//         if (!billingDetails || !billingDetails.billingid) {
//           toast.error('Billing details not found. Please try again.');
//           return;
//         }

//         const billingId = billingDetails.billingid;
//         const bookingId = bookingDetails.bookingid;

//         const apiUrl = `${BQ_BASE_URL}/bq/api/razorpay/create_payment_order?billingid=${billingId}&bookingid=${bookingId}`;

//         const response = await fetch(apiUrl, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//             Accept: 'application/json',
//           },
//         });

//         if (!response.ok) throw new Error('Failed to create payment order');

//         const orderData = await response.json();

//         if (orderData && orderData.razorpay_order_id) {
//           const options = {
//             key: REACT_APP_RAZORPAY_KEY,
//             amount: orderData.amount,
//             currency: 'INR',
//             name: 'Pagoda Hotel',
//             description: selectedService.roomservices_name, // Show service name in payment
//             order_id: orderData.razorpay_order_id,
//             handler: async function (response) {
//               const paymentDetails = {
//                 razorpay_order_id: response.razorpay_order_id,
//                 razorpay_payment_id: response.razorpay_payment_id,
//                 razorpay_signature: response.razorpay_signature,
//               };

//               try {
//                 const verificationResponse = await fetch(
//                   `${BQ_BASE_URL}/bq/api/razorpay/verify_payment`,
//                   {
//                     method: 'POST',
//                     headers: {
//                       'Content-Type': 'application/json',
//                       Accept: 'application/json',
//                     },
//                     body: JSON.stringify(paymentDetails),
//                   }
//                 );

//                 if (verificationResponse.ok) {
//                   toast.success('Payment successful and verified!');
//                   window.location.href = '/roomservice-payment-succesful';
//                 } else {
//                   toast.error('Payment verification failed.');
//                 }
//               } catch (error) {
//                 console.error('Verification error:', error);
//                 toast.error('Error verifying payment. Please try again.');
//               }
//             },
//             prefill: {
//               name: `${bookingDetails.firstname} ${bookingDetails.lastname}`,
//               email: bookingDetails.emailid,
//               contact: bookingDetails.phonenumber.toString(),
//             },
//             theme: {
//               color: '#3399cc',
//             },
//           };

//           const rzp = new window.Razorpay(options);
//           rzp.open();
//         }
//       } catch (error) {
//         console.error('Payment error:', error);
//         toast.error('Error processing payment. Please try again.');
//       }
//     } else if (paymentMethod === 'payLater') {
//       toast.info('Payment deferred. Please pay at the front desk.');
//       localStorage.removeItem('selectedService');
//       localStorage.removeItem('billingDetails');
//       setShowPaymentModal(false);
//     }
//   };

//   const handleBookClick = (service) => {
//     setSelectedService({
//       ...service,
//       category_name: service.name, // Since these are categories, their name IS the category name
//     });
//     console.log(selectedService);
//     setFormData({ ...formData, serviceName: service.name });
//     setIsModalOpen(true);
//   };

//   const handlePreview = () => {
//     console.log('Preview data:', formData);
//     alert('Preview functionality would show a summary here');
//   };

//   const handleBook = () => {
//     console.log('Booking data:', formData);
//     alert('Booking submitted successfully!');
//     setIsModalOpen(false);
//   };

//   return (
//     <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
//       <NavLink
//         to="/dashboard/core-modules/property-management-system/front-desk-roomservices"
//         className="flex items-center text-gray-400 hover:text-black mb-4"
//       >
//         <FaArrowLeft className="mr-3 text-md" /> {/* Left arrow icon */}
//         <span className="text-lg">Back to Room Services </span>
//       </NavLink>

//       <div className="px-10 mt-2 mx-auto">
//         <div className="text-center mb-12">
//           <h1 className="text-3xl font-bold text-gray-900 mb-2">Room Services</h1>
//           <h2 className="text-md font-semibold text-center mb-1 text-black">
//             Enhance your stay with our premium in-room offerings designed for comfort, convenience,
//             and celebration.
//           </h2>
//           <hr className="border border-gray-300 w-1/4 mx-auto mb-4" />
//         </div>

//         <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
//           {services.map((service) => (
//             <ServiceCard key={service.id} service={service} onBookClick={handleBookClick} />
//           ))}
//         </div>
//       </div>

//       {isModalOpen && (
//         <BookingModal
//           formData={formData}
//           setFormData={setFormData}
//           selectedService={selectedService}
//           onClose={() => setIsModalOpen(false)}
//           onPreview={handlePreview}
//           onBook={handleBook}
//           confirmServiceBooking={confirmServiceBooking}
//         />
//       )}
//       {showPaymentModal && (
//         <div className="fixed inset-0 flex justify-center items-center bg-gray-800 bg-opacity-70 z-50">
//           <div className="bg-white p-6 rounded-lg w-4/12 text-center shadow-md transform transition-all duration-200">
//             <h3 className="text-2xl font-semibold mb-4 text-gray-900">Complete Your Payment</h3>
//             <p className="text-md text-gray-600 mb-6">
//               Your booking has been successfully confirmed! Please select a payment method to
//               proceed:
//             </p>

//             <div className="flex justify-center gap-4">
//               <button
//                 onClick={() => handlePaymentOption('payLater')}
//                 className="bg-black text-white px-10 py-2 rounded-md hover:text-gray-200 transition-all duration-200 font-semibold"
//               >
//                 Pay Later
//               </button>
//               <button
//                 onClick={() => handlePaymentOption('payNow')}
//                 className="bg-green-600 text-white px-10 py-2 rounded-md hover:text-black transition-all duration-200 font-semibold"
//               >
//                 Pay Now
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//       <ToastContainer />
//     </div>
//   );
// };

// export default OrderRoomServices;
